import React from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import i18n from "i18next";
import { createRoot } from "react-dom/client";
import { initReactI18next } from "react-i18next";
import { BrowserRouter } from "react-router-dom-v5-compat";

import onsite_au from "../locales/en-au/onsite.json";
import onsite_gb from "../locales/en-gb/onsite.json";
import onsite_nz from "../locales/en-nz/onsite.json";
import onsite from "../locales/en/onsite.json";
import App from "../onsite_app";
import "../styles/Onsite.css";

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    debug: true,
    resources: {
      en: { onsite },
      "en-NZ": { onsite: onsite_nz },
      "en-AU": { onsite: onsite_au },
      "en-GB": { onsite: onsite_gb },
    },
    lng: "en",
    fallbackLng: "en",
    defaultNS: "onsite",
    ns: "onsite",
  });

const queryClient = new QueryClient();
document.addEventListener("DOMContentLoaded", () => {
  const baseRoute = (window as { baseRoute?: string }).baseRoute;
  const container = document.getElementById("App");
  const root = createRoot(container!);
  root.render(
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>,
  );
});
